import type { SVGProps } from "react";

/** SOXIE365 wordmark traced from the printed box artwork. Inherits currentColor. */
export function Wordmark({ title = "SOXIE365", ...props }: SVGProps<SVGSVGElement> & { title?: string }) {
  return (
    <svg viewBox="0 0 2064.000000 512.000000" role="img" aria-label={title} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
        <path d="M4865 3950 c-654 -54 -1089 -439 -1200 -1060 -23 -127 -31 -435 -16
-571 23 -199 70 -365 143 -514 177 -357 480 -570 921 -646 155 -27 700 -39
909 -19 694 64 1107 422 1223 1060 23 125 31 448 15 578 -87 707 -503 1105
-1225 1172 -123 11 -632 11 -770 0z m856 -668 c227 -62 374 -215 441 -457 33
-118 33 -441 0 -560 -62 -227 -205 -387 -401 -449 -113 -36 -228 -46 -511 -46
-423 0 -566 34 -711 167 -152 141 -220 326 -220 601 0 389 147 642 424 732
103 33 190 39 547 36 325 -2 361 -4 431 -24z"/>
        <path d="M1364 3909 c-488 -37 -781 -297 -835 -739 -48 -399 119 -716 448
-849 195 -80 311 -90 1008 -91 481 0 580 -2 630 -15 128 -34 169 -88 163 -216
-4 -105 -49 -162 -148 -189 -23 -6 -408 -11 -1029 -12 l-991 -2 0 -313 0 -313
1023 0 c854 0 1037 3 1112 15 420 69 652 289 710 674 66 433 -98 761 -450 902
-184 73 -217 76 -1096 87 l-525 7 -59 30 c-70 36 -92 63 -106 135 -15 74 1
132 50 181 72 73 41 71 1011 74 476 2 909 4 963 4 l97 1 0 320 0 320 -937 -1
c-516 -1 -983 -5 -1039 -10z"/>
        <path d="M6730 3913 c0 -10 163 -195 962 -1096 l247 -279 -142 -162 c-78 -88
-212 -240 -297 -336 -86 -96 -283 -321 -439 -500 -156 -179 -293 -335 -304
-348 l-20 -22 424 0 424 0 165 187 c172 194 330 373 514 583 60 69 112 126
116 128 4 1 132 -140 286 -315 153 -175 332 -378 397 -450 l118 -133 435 0
435 0 -93 107 c-107 123 -422 481 -638 723 -368 414 -490 554 -488 561 2 4 75
90 164 191 324 369 552 628 753 857 113 129 221 251 239 273 l34 38 -424 0
-424 0 -200 -227 c-109 -124 -270 -307 -356 -405 -86 -98 -173 -198 -193 -222
l-36 -45 -72 82 c-40 44 -126 142 -192 217 -66 75 -212 241 -325 368 l-205
232 -432 0 c-238 0 -433 -3 -433 -7z"/>
        <path d="M10340 3913 c1 -5 -2 -623 -6 -1375 l-6 -1368 336 0 336 0 -2 1373
-3 1372 -327 3 c-181 1 -328 -1 -328 -5z"/>
        <path d="M11380 2545 l0 -1375 1255 0 1255 0 0 315 0 315 -925 -2 -925 -3 0
223 0 222 875 0 875 0 0 305 0 305 -875 0 -875 0 0 209 0 209 58 6 c31 3 447
5 924 3 l868 -2 0 323 0 322 -1255 0 -1255 0 0 -1375z"/>
        <path d="M14930 3891 c-274 -60 -480 -219 -595 -462 -37 -79 -75 -212 -75
-265 0 -37 3 -38 236 -50 l121 -6 12 60 c47 240 242 392 501 392 211 -1 352
-76 427 -228 38 -76 38 -76 38 -202 0 -117 -2 -129 -28 -182 -83 -170 -243
-238 -559 -238 l-138 0 0 -170 0 -170 183 0 c212 0 288 -13 394 -65 283 -140
284 -591 0 -759 -164 -97 -433 -105 -615 -19 -121 57 -223 188 -253 326 l-12
57 -184 0 c-149 0 -183 -3 -183 -14 0 -41 36 -191 61 -258 101 -261 307 -426
611 -489 147 -30 407 -23 550 14 449 118 692 532 578 983 -53 207 -185 343
-399 410 -7 2 20 21 60 41 199 100 309 298 309 559 0 147 -19 237 -76 354 -88
180 -257 311 -479 371 -116 31 -366 36 -485 10z"/>
        <path d="M17104 3891 c-367 -86 -641 -394 -754 -847 -112 -452 -95 -1042 41
-1377 66 -165 216 -346 351 -425 218 -129 574 -150 827 -50 371 146 600 565
553 1006 -50 455 -337 738 -772 759 -285 14 -521 -94 -692 -317 l-27 -35 5 40
c71 547 240 830 536 900 224 53 451 -29 584 -209 l49 -66 134 134 134 134 -54
68 c-105 130 -263 230 -434 275 -117 31 -368 36 -481 10z m285 -1296 c235 -62
373 -262 374 -540 0 -290 -162 -518 -408 -575 -76 -18 -221 -16 -290 5 -188
54 -323 199 -370 396 -73 311 83 620 359 709 97 31 228 34 335 5z"/>
        <path d="M18600 3823 c0 -26 -38 -337 -131 -1081 -22 -178 -39 -326 -36 -328
2 -3 82 -20 178 -39 l174 -34 50 56 c199 223 582 249 789 53 104 -98 150 -224
149 -410 0 -190 -46 -314 -158 -425 -102 -103 -218 -145 -393 -145 -175 0
-297 46 -403 151 -50 50 -110 150 -132 221 -5 14 -27 6 -144 -51 -76 -37 -153
-73 -171 -80 -39 -16 -38 -19 24 -141 119 -231 327 -377 608 -426 140 -25 382
-15 498 20 369 110 595 392 639 796 41 372 -108 708 -381 863 -259 146 -678
124 -903 -47 -26 -20 -47 -30 -47 -23 0 23 90 722 95 735 3 9 127 12 572 12
l568 0 3 175 3 175 -725 0 -726 0 0 -27z"/>
      </g>
    </svg>
  );
}
